/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ListScheduledDowntimeResponse,
  ScheduledDowntime,
  ScheduledDowntimeUpsertRequest,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ListScheduledDowntimeResponseFromJSON,
    ListScheduledDowntimeResponseToJSON,
    ScheduledDowntimeFromJSON,
    ScheduledDowntimeToJSON,
    ScheduledDowntimeUpsertRequestFromJSON,
    ScheduledDowntimeUpsertRequestToJSON,
} from '../models/index';

export interface CreateScannerScheduledDowntimeRequest {
    customerId: string;
    scheduledDowntimeUpsertRequest: ScheduledDowntimeUpsertRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeleteScannerScheduledDowntimeRequest {
    customerId: string;
    id: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface ListScannerScheduledDowntimeRequest {
    customerId: string;
    includePast?: boolean;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateScannerScheduledDowntimeRequest {
    customerId: string;
    id: string;
    scheduledDowntimeUpsertRequest: ScheduledDowntimeUpsertRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class TicketScannerScheduledDowntimeApi extends runtime.BaseAPI {

    /**
     */
    async createScannerScheduledDowntimeRaw(requestParameters: CreateScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScheduledDowntime>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createScannerScheduledDowntime().'
            );
        }

        if (requestParameters['scheduledDowntimeUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'scheduledDowntimeUpsertRequest',
                'Required parameter "scheduledDowntimeUpsertRequest" was null or undefined when calling createScannerScheduledDowntime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:ticket-scanner-downtime"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/scheduled-downtime`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduledDowntimeUpsertRequestToJSON(requestParameters['scheduledDowntimeUpsertRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduledDowntimeFromJSON(jsonValue));
    }

    /**
     */
    async createScannerScheduledDowntime(requestParameters: CreateScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScheduledDowntime> {
        const response = await this.createScannerScheduledDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteScannerScheduledDowntimeRaw(requestParameters: DeleteScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deleteScannerScheduledDowntime().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteScannerScheduledDowntime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:ticket-scanner-downtime"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/scheduled-downtime/{id}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteScannerScheduledDowntime(requestParameters: DeleteScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScannerScheduledDowntimeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async listScannerScheduledDowntimeRaw(requestParameters: ListScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListScheduledDowntimeResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listScannerScheduledDowntime().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includePast'] != null) {
            queryParameters['includePast'] = requestParameters['includePast'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:ticket-scanner-downtime"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/scheduled-downtime`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListScheduledDowntimeResponseFromJSON(jsonValue));
    }

    /**
     */
    async listScannerScheduledDowntime(requestParameters: ListScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListScheduledDowntimeResponse> {
        const response = await this.listScannerScheduledDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateScannerScheduledDowntimeRaw(requestParameters: UpdateScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScheduledDowntime>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateScannerScheduledDowntime().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateScannerScheduledDowntime().'
            );
        }

        if (requestParameters['scheduledDowntimeUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'scheduledDowntimeUpsertRequest',
                'Required parameter "scheduledDowntimeUpsertRequest" was null or undefined when calling updateScannerScheduledDowntime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:ticket-scanner-downtime"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/scheduled-downtime/{id}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduledDowntimeUpsertRequestToJSON(requestParameters['scheduledDowntimeUpsertRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduledDowntimeFromJSON(jsonValue));
    }

    /**
     */
    async updateScannerScheduledDowntime(requestParameters: UpdateScannerScheduledDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScheduledDowntime> {
        const response = await this.updateScannerScheduledDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
